<template>
	<div class="l-content-section skicheck-info">
		<div class="l-row">
			<div class="l-col l-col--12 l-col--5@md">
				<div class="skicheck-info__section-inner-w">
					<SectionTitle
						:title="$I18n.trans('skicheck_info.banner.title')"
						type="md"
					/>
					<!-- eslint-disable vue/no-v-html -->
					<div
						class="s-html -sm"
						v-html="$I18n.trans('skicheck_info.banner.copy')"
					/>
				</div>
			</div>
			<div class="l-col l-col--12 l-col--6@md l-offset--1@md">
				<div class="skicheck-info__section-inner-w -img">
					<img
						src="/images/skicheck/skicheck.webp"
						alt=""
					>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import SectionTitle from '@js/components/SectionTitle';

export default {
	name:       'SkicheckInfo',
	components: { SectionTitle },
};
</script>

<style lang="scss" scoped>
@import '@sass/variables';

.skicheck-info {
	position: relative;
	margin-bottom: $sp6;

	&::after {
		content: '';
		display: block;
		background-color: var(--color-grey-900);
		height: 100%;
		width: 100vw;
		position: absolute;
		top: 0;
		left: 50%;
		transform: translateX(-50%);
		z-index: -1;
		pointer-events: none;
	}
}

.skicheck-info__section-inner-w {
	padding-bottom: $sp6;

	&:not(.-img) {
		padding-top: $sp6;

		@include size(md-up) {
			padding-top: $sp8-5;
		}
	}

	@include size(md-up) {
		padding-top: $sp8-5;
		padding-bottom: $sp8-5;
	}
}
</style>
